import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_TICKETS } from "../../../utils/constants";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import ticketService from "../../../services/ticketService/ticketService";

const useTicketById = (id: string | undefined) =>
  useQuery<TicketInterface, Error>({
    queryKey: [`${CACHE_KEY_TICKETS}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, ticketId] = queryKey;
      return ticketService.GetById(ticketId as string);
    },
    enabled: !!id, // Only run the query if id is truthy (not undefined or an empty string)
  });

export default useTicketById;
